import { Injectable } from '@angular/core';
import { AgreementStorageDataModel } from './agreement-storage-data.model';
import { AgreementItemModel } from './agreement-item.model';

@Injectable()
export class AgreementsStorageService {
  public groups: { [id: number]: AgreementStorageDataModel } = {};
  public allAgreements: { [id: string]: AgreementItemModel } = {};

  public createGroupStorage(groupId: number, parentStorage?: AgreementStorageDataModel): AgreementStorageDataModel {
    const group = this.getGroupById(groupId);

    if (!group) {
      return this.groups[groupId] = new AgreementStorageDataModel(groupId, parentStorage);
    }

    return group;
  }

  public getGroupById(groupId: number): AgreementStorageDataModel | null {
    return (this.groups.hasOwnProperty(groupId.toString())) ? this.groups[groupId] : null;
  }

  public addAgreement(agreementItem: AgreementItemModel): void {
    this.allAgreements[agreementItem.omsCode] = agreementItem;
  }

  public getAgreementItemByOmsCode(omsCode: string): AgreementItemModel | null {
    return this.allAgreements[omsCode] || null;
  }

  public clear(): void {
    this.groups = {};
  }
}
